module.exports = __webpack_public_path__ + "static/meditators-c2519af66863b2919677fb4dc37943fa.jpg";